<form class="example-form">

    <input type="text" placeholder="Institution" aria-label="Assignee" matInput [formControl]="myControl" [matAutocomplete]="auto" required>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{option.name}} [{{option.nickname}}]
      </mat-option>
    </mat-autocomplete>

</form>

